// @ts-nocheck
import { lazy } from 'react';
export const EditCompanyScreenAsync = lazy(
  () => import('./EditCompanyScreen.tsx'),
);
